export const validateErrorCodesMercadoPago = (
  errors: {
    code: string;
    message: string;
  }[],
) => {
  //https://www.mercadopago.com.ar/developers/es/docs/checkout-api/response-handling/data-insertion-errors
  const initialValue = {};
  const errorEmpty = (key: string) => `form.${key}.errors.empty`;
  const errorInvalid = (key: string) => `form.${key}.errors.invalid`;

  const parseErrorMessage = (code: string) =>
    ({
      E203: { securityCode: errorInvalid('securityCode') },
      '205': { cardNumber: errorEmpty('cardNumber') },
      '208': { expirationDate: errorEmpty('expirationDate') },
      '209': { expirationDate: errorEmpty('expirationDate') },
      '212': { identificationType: errorEmpty('identificationType') },
      '213': { identificationType: errorEmpty('identificationType') },
      '214': {
        identificationNumberParsed: errorEmpty('identificationNumberParsed'),
      },
      // 220 empty cardIssuerId
      '221': { cardholderName: errorEmpty('cardholderName') },
      '224': { securityCode: errorEmpty('securityCode') },
      E301: { cardNumber: errorInvalid('cardNumber') },
      '316': {
        cardholderName: errorInvalid('cardholderName'),
      },
      '322': { identificationType: errorInvalid('identificationType') },
      '323': { identificationType: errorInvalid('identificationType') },
      '324': {
        identificationNumberParsed: errorInvalid('identificationNumberParsed'),
      },
      '325': { expirationDate: errorInvalid('expirationDate') },
      '326': { expirationDate: errorInvalid('expirationDate') },
    }[code] ?? {});

  return errors.reduce(
    (acc, { code }) => ({
      ...acc,
      ...parseErrorMessage(code),
    }),
    initialValue,
  );
};
